import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-base" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" System will delete the item artwork. Continue? ")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WarningFilled = _resolveComponent("WarningFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_ApplyForAllVariantCheckbox = _resolveComponent("ApplyForAllVariantCheckbox")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_close_button = _resolveComponent("close-button")!
  const _component_save_button = _resolveComponent("save-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dialogVisible) = $event)),
    title: "Delete confirm",
    width: "30%"
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_close_button, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogVisible = false))
      }),
      _createVNode(_component_save_button, {
        label: "Confirm",
        onClick: _ctx.onConfirmDelete
      }, null, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [
            _createVNode(_component_WarningFilled)
          ]),
          _: 1
        }),
        _hoisted_2
      ]),
      _createVNode(_component_el_row, { class: "flex items-center justify-between" }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createVNode(_component_ApplyForAllVariantCheckbox, {
            modelValue: _ctx.isApply,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isApply) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}